import React from 'react';
import Message from 'components/Message';
import Badge from 'components/Badge';
import PropTypes from 'prop-types';
import { Card, CardSection, CardTitle } from 'components/Card';
import { bem } from 'helpers/class-name';
import { BackNavLink } from 'features/App';
import messages from './ViewWaiver.messages';
import './ViewWaiver.scss';

const { element } = bem('view-waiver');

const ViewWaiver = ({ isLoading, outOfDate, backToClassesHref, firstName, lastName, signedOn, waiverHTML: __html }) => {
  if (isLoading) {
    return <Card isLoading />;
  }

  return (
    <>
      <BackNavLink to={backToClassesHref} />
      <Card className="mt-giga" flush>
        <div className={element('title-wrap', 'pv-sp', 'ph-l')}>
          <CardTitle>
            <div>
              <Message message={messages.title} />
              {outOfDate && <Message as={Badge} className="ml-r" message={messages.outOfDate} warn solid />}
            </div>
          </CardTitle>
          <div>
            {firstName} {lastName}
          </div>
          <Message
            className={element('signed-on', 'text--light ml-l')}
            message={messages.signed}
            values={{ signedOn: new Date(signedOn) }}
          />
        </div>
        <CardSection className="border-t">
          <div dangerouslySetInnerHTML={{ __html }} />
        </CardSection>
      </Card>
    </>
  );
};

ViewWaiver.propTypes = {
  isLoading: PropTypes.bool,
  outOfDate: PropTypes.bool,
  backToClassesHref: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  signedOn: PropTypes.instanceOf(Date),
  waiverHTML: PropTypes.string,
};

export default ViewWaiver;
